import { apiClient } from '@/shared/lib/axios';
import type {
  DeleteClinic,
  DeleteClinicListQuery,
  DeleteClinicListResponse,
} from '@/types/admin-delete-clinic';

type ApiEnvelope<T = unknown> = { success?: boolean; message?: string; data: T };

export const getDeleteClinicList = async (
  siteType: string,
  query?: DeleteClinicListQuery
): Promise<DeleteClinicListResponse> => {
  const response = await apiClient.get<DeleteClinicListResponse>(
    `/admin/${siteType}/delete-clinics`,
    { params: query }
  );
  // Backend returns { success, data, meta } at the root (not nested under data envelope).
  return response.data;
};

export const restoreDeleteClinic = async (
  siteType: string,
  id: number
): Promise<DeleteClinic> => {
  const response = await apiClient.post<ApiEnvelope<DeleteClinic>>(
    `/admin/${siteType}/delete-clinics/${id}/restore`
  );
  return response.data.data;
};
